import { render, staticRenderFns } from "./IconReportEmail.vue?vue&type=template&id=51e98973"
import script from "./IconReportEmail.vue?vue&type=script&lang=js"
export * from "./IconReportEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e98973')) {
      api.createRecord('51e98973', component.options)
    } else {
      api.reload('51e98973', component.options)
    }
    module.hot.accept("./IconReportEmail.vue?vue&type=template&id=51e98973", function () {
      api.rerender('51e98973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/s/IconReportEmail.vue"
export default component.exports